/*
  Arrow controls for the benefits slider.

  The track is a scroll-snap scroller, so it already works by swipe, trackpad and keyboard
  with no JavaScript at all. This file only adds the arrows, and it unhides them itself —
  Liquid ships them `hidden` so a control that cannot move anything is never painted.

  Everything is measured off the track at click time rather than cached: the section is
  a grid above 900px and a scroller below it, and the card width changes with the
  viewport. Reading `scrollLeft` and the first card's width when asked keeps the two
  layouts from needing separate code paths.
*/
(function () {
  var roots = document.querySelectorAll('[data-dp-benefits]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var track = root.querySelector('[data-dp-benefits-track]');
    var prev = root.querySelector('[data-dp-benefits-prev]');
    var next = root.querySelector('[data-dp-benefits-next]');
    if (!track || !prev || !next) return;

    var cards = track.children;
    if (cards.length < 2) return;

    prev.hidden = false;
    next.hidden = false;

    function step() {
      // Card width plus whatever gap the layout is using, read live.
      var first = cards[0];
      var second = cards[1];
      if (!second) return first.getBoundingClientRect().width;
      return second.getBoundingClientRect().left - first.getBoundingClientRect().left;
    }

    function scrollable() {
      return track.scrollWidth - track.clientWidth;
    }

    function sync() {
      // 1px of slack: sub-pixel layout means scrollLeft rarely hits either end exactly.
      var max = scrollable();
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
      // With nothing to scroll (the desktop grid) neither arrow has a job.
      var idle = max <= 1;
      prev.hidden = idle;
      next.hidden = idle;
    }

    function go(direction) {
      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({
        left: step() * direction,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () {
      go(-1);
    });
    next.addEventListener('click', function () {
      go(1);
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
